<ng-container
  [ngTemplateOutlet]="template ? template : defaultTemplate"
  [ngTemplateOutletContext]="{
    $implicit: node,
    level: level
  }"
></ng-container>

<ng-container *ngIf="getChildren(node)?.length">
  <mode-tree
		*ngFor="let child of getChildren(node); trackBy: trackById"
		[node]="child"
    [template]="template ? template : defaultTemplate"
    [level]="level + 1"
    [getId]="getId"
    [getChildren]="getChildren"
	></mode-tree>
</ng-container>

<ng-template #defaultTemplate>
  {{ getId(node) }}
</ng-template>
